import Portfolio4GridContainer from "../../../../components/pages/portfolio/portfolioPage/Portfolio4Grid";

const Portfolio4Grid = () => {
  return <Portfolio4GridContainer />;
};

export default Portfolio4Grid;
